export default __webpack_public_path__ + "static/media/apoditiria_amea.791e6ff8.svg";